<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="推广者编号：" prop="member_code">
                <span>{{model.member_code}}</span>
            </el-form-item>
            <el-form-item label="姓名：" prop="name">
                <span>{{model.name}}</span>
            </el-form-item>
            <el-form-item label="手机号：" prop="cellphone">
                <span>{{model.cellphone}}</span>
            </el-form-item>
            <el-form-item label="结算批次：" prop="settled_batch">
                <span>{{model.settled_batch}}</span>
            </el-form-item>
            <el-form-item label="结算状态：" prop="settled_state">
                <span>{{ transEnu(model.settled_state, "settled_state") }}</span>
            </el-form-item>
            <el-form-item label="结算时间：" prop="settled_time">
                <span>{{model.settled_time}}</span>
            </el-form-item>
            <el-form-item label="预计结算时间：" prop="settled_time_yu">
                <span>{{model.settled_time_yu}}</span>
            </el-form-item>
            <el-form-item label="订单编号：" prop="sn">
                <span>{{model.sn}}</span>
            </el-form-item>
            <el-form-item label="订单状态：" prop="status">
                <span>{{ transEnu(model.status, "order_status") }}</span>
            </el-form-item>
            <el-form-item label="支付时间：" prop="paytime">
                <span>{{model.paytime}}</span>
            </el-form-item>
            <el-form-item label="完成时间：" prop="completetime">
                <span>{{model.completetime}}</span>
            </el-form-item>
            <el-form-item label="收货人电话：" prop="receiver_phone">
                <span>{{model.receiver_phone}}</span>
            </el-form-item>
            <el-form-item label="商品数量：" prop="goods_count">
                <span>{{model.goods_count}}</span>
            </el-form-item>
            <el-form-item label="支付金额：" prop="pay_price">
                <span>{{model.pay_price}}</span>
            </el-form-item>
            <el-form-item label="佣金：" prop="commission">
                <span>{{model.commission}}</span>
            </el-form-item>
            <el-form-item label="团购订单：" prop="is_tuan">
                <span>{{ transEnu(model.is_tuan, "yesNo") }}</span>
            </el-form-item>
        </el-form>
        <div class="dataBox" style="margin-top: 20px">
            <el-table :data="orderItems" border stripe>
                <el-table-column prop="goods_name" label="商品名称" sortable="custom"></el-table-column>
                <el-table-column prop="spec" label="规格名称" sortable="custom" width="160"></el-table-column>
                <el-table-column prop="sku" label="规格编码" sortable="custom" width="160"></el-table-column>
                <el-table-column prop="price" label="价格" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="num" label="数量" sortable="custom" width="100"></el-table-column>
                <el-table-column prop="commission" label="佣金" sortable="custom" width="100"></el-table-column>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { getModelById } from '@/api/common'

export default {
    name: 'promotionOrderInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                member_id: '',
                member_code: '',
                name: '',
                cellphone: '',
                settled_batch: '',
                settled_state: '',
                settled_time: '',
                settled_time_yu: '',
                order_id: '',
                sn: '',
                status: '',
                paytime: '',
                completetime: '',
                receiver_phone: '',
                goods_count: '',
                pay_price: '',
                commission: '',
                is_tuan: '',
            },
            orderItems: null,
            getObj:{
                url:'/api/admin/promotionorder/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: ['yesNo', 'order_status', 'settled_state'],
        };
    },
    methods: {
        getModelData() {
            this.model = this.copyObj(this.init_model);
            if (this.id > 0) {
                this.getObj.data.value = this.id;
                getModelById(this.getObj).then(res => {
                    if (res.code === 1) {
                        this.model = res.data.order;
                        this.orderItems = res.data.orderItems;
                        this.formateData();
                    } else {
                        this.$msg(res.msg)
                        this.closeDialog()
                    }
                })
            }
        },
    }
};
</script>